import React from "react";
import { FiDownload } from "react-icons/fi";
import Button from "./ui/Button";

/**
 * CSV export. Logic is unchanged from the original implementation;
 * only the button styling was moved to the design-system Button.
 */
export default function ExportButton({ data, filename = "export", onExport }) {
    const exportToCSV = () => {
        if (!data || data.length === 0) {
            alert("Tidak ada data untuk di-export");
            return;
        }

        const headers = Object.keys(data[0]);

        const csvContent = [
            headers.join(","),
            ...data.map((row) =>
                headers
                    .map((header) => {
                        const value = row[header];
                        if (typeof value === "string" && (value.includes(",") || value.includes('"'))) {
                            return `"${value.replace(/"/g, '""')}"`;
                        }
                        return value ?? "";
                    })
                    .join(",")
            ),
        ].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.setAttribute("href", url);
        link.setAttribute("download", `${filename}_${new Date().toISOString().split("T")[0]}.csv`);
        link.style.visibility = "hidden";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        if (onExport) {
            onExport("csv");
        }
    };

    return (
        <Button variant="secondary" icon={FiDownload} onClick={exportToCSV}>
            Export CSV
        </Button>
    );
}
